import {createRequestDataSource} from '@ngneat/elf-requests';
import {select} from '@ngneat/elf';

import {statisticsStore} from '@store/statistics/statistics.store';
import {ServiceKindTypeEnum} from '@store/settings/serviceKinds';
import {map} from 'rxjs';
import {ExecutionCountByServiceKind} from '@store/statistics/statistics.model';

export const getEvolutionOfOperationsDataSource = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.operations.evolutionOfOperations)),
  requestKey: 'getEvolutionOfOperations',
  dataKey: 'evolutionOfOperations',
});

export const getTurnoverAndPurchaseDataSource = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.turnoverAndPurchaseEvolution)),
  requestKey: 'getTurnoverAndPurchase',
  dataKey: 'turnoverAndPurchase',
});

export const getTotalTurnoverNewDataSource = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.totalTurnover)),
  requestKey: 'getTotalTurnoverNew',
  dataKey: 'totalTurnoverNew',
});

export const getMostProfitableClients = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.clientsTurnover)),
  requestKey: 'getMostProfitableClients',
  dataKey: 'clientsTurnover',
});


export const getInvoicingProgression = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.donutChart)),
  requestKey: 'getDonutChart',
  dataKey: 'donutChart',
});

export const getCurveChartDataSource = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.curveChart)),
  requestKey: 'getCurveChart',
  dataKey: 'curveChart',
});

export const getMarginByLineDataSource = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.marginByLine)),
  requestKey: 'getMarginByLine',
  dataKey: 'marginByLine',
});

export const getTurnoverChargesServiceKind = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.turnoverAndChargesByServiceKind), map(d => d?.filter(e => e.serviceKindType !== ServiceKindTypeEnum.VALORISATION))),
  requestKey: 'getTurnoverChargesServiceKind',
  dataKey: 'turnoverAndChargesByServiceKind',
});

export const getTurnoverChargesValo = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.turnoverAndChargesByServiceKind), map(d => d?.find(e => e.serviceKindType === ServiceKindTypeEnum.VALORISATION))),
  requestKey: 'getTurnoverChargesValo',
  dataKey: 'turnoverChargesValo',
});

export const getValoWeightByWasteFamily = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.valoWeightByWasteFamily)),
  requestKey: 'getValoWeightByWasteFamily',
  dataKey: 'valoWeightByWasteFamily',
});

export const getExecutionCountPickup = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.executionCountByServiceKind), map(d => d?.filter(e => e.serviceKindType === ServiceKindTypeEnum.PICKUP))),
  requestKey: 'getExecutionCountPickup',
  dataKey: 'executionCountPickup',
});

export const getExecutionCountProcessingValo = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.executionCountByServiceKind), map(d => d?.filter(e => [ServiceKindTypeEnum.PROCESSING, ServiceKindTypeEnum.VALORISATION].includes(e.serviceKindType)))),
  requestKey: 'getExecutionCountProcessingValo',
  dataKey: 'executionCountProcessingValo',
});

export const getExecutionCountRenting = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.executionCountByServiceKind), map(d => d?.filter(e => [ServiceKindTypeEnum.RENTING].includes(e.serviceKindType)))),
  requestKey: 'getExecutionCountRenting',
  dataKey: 'executionCountRenting',
});

export const getExecutionCountOther = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.executionCountByServiceKind), map(d => d?.filter(e => ![ServiceKindTypeEnum.RENTING, ServiceKindTypeEnum.PICKUP, ServiceKindTypeEnum.PROCESSING, ServiceKindTypeEnum.VALORISATION].includes(e.serviceKindType)))),
  requestKey: 'getExecutionCountOther',
  dataKey: 'executionCountOther',
});

export const getExecutionCountAll = createRequestDataSource({
  store: statisticsStore,
  data$: () => statisticsStore.pipe(select((state) => state.finance.executionCountByServiceKind?.reduce((acc: ExecutionCountByServiceKind[], val) => {
    const familyIndex = acc.findIndex(e => e.serviceKindName === val.serviceKindType);

    if (familyIndex > -1) {
      acc[familyIndex].execCount += val.execCount;
    } else {
      acc.push({
        serviceKindName: val.serviceKindType,
        serviceKindType: val.serviceKindType,
        execCount: val.execCount,
      });
    }

    return acc;

  }, []).map(e => ({
    ...e,
    serviceKindName: (ServiceKindTypeEnum.selectItems().find((s) => s.value === e.serviceKindName)?.label || '').toUpperCase()
  })))),
  requestKey: 'getExecutionCountAll',
  dataKey: 'executionCountAll',
});
